import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { featureFlagGuard } from '../core/feature-flags/feature-flag-guard';
import { Features } from '../core/feature-flags/features';
import { CanDeactivateGuard } from '../core/guards/can-deactivate.guard';
import { SingleSponsorContentFormComponent } from './components/single-sponsor-content-form/single-sponsor-content-form.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: 'new', pathMatch: 'full' },
      {
        path: 'new',
        component: SingleSponsorContentFormComponent,
        canActivate: [
          featureFlagGuard(Features.SINGLE_SPONSOR, false, '/dashboard'),
        ],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: ':id',
        pathMatch: 'full',
        component: SingleSponsorContentFormComponent,
        canActivate: [
          featureFlagGuard(Features.SINGLE_SPONSOR, false, '/dashboard'),
        ],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: ':id/edit',
        component: SingleSponsorContentFormComponent,
        canActivate: [
          featureFlagGuard(Features.SINGLE_SPONSOR, false, '/dashboard'),
        ],
        canDeactivate: [CanDeactivateGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SingleSponsorContentRoutingModule {}
